module.exports = __webpack_public_path__ + "static/img/third1_8.2201b8ee.png";